import mobileNav from "../nav/mobile-nav";
import desktopNav from "../nav/desktop-nav";

document.addEventListener("DOMContentLoaded", () => {
    desktopNav();
    mobileNav();
})